import type { RelationshipTargetKind } from '@cli-types/core-engine/add-field.js'
import { readRelationshipTargetKind } from '@core-engine/schema/add-field/read-relationship-target-kind.js'
import { fail } from '../schema-prompts/fail.js'

export function validateRelationshipTarget(
  schemasDir: string,
  targetSchema: string | undefined,
  fieldType: string | undefined
): void {
  if (!targetSchema || fieldType !== 'relationship') {
    return
  }

  let targetKind: RelationshipTargetKind
  try {
    targetKind = readRelationshipTargetKind(schemasDir, targetSchema)
  } catch (error) {
    fail(`Relationship target error: ${error instanceof Error ? error.message : String(error)}`)
  }

  if (targetKind === 'form') {
    fail('Relationship fields can target Entity and Single schemas only, not form schemas.')
  }
}
